import {connect} from 'react-redux';
import {CategoryPage} from 'src/pages/category/components/CategoryPage';
import {changeTopics} from 'src/pages/category/store/actions/topics';
import {
  selectedSubtopic,
  selectedTopic,
} from 'src/pages/category/store/selectors/topics';
import {content} from 'src/shared/content/selectors';
import {launchXfinityAssistant} from 'src/shared/xfinityAssistant/actions';

export const mapStateToProps = state => ({
  category: content(state).category,
  selectedTopic: selectedTopic(state),
  selectedSubtopic: selectedSubtopic(state),
});

export const mapDispatchToProps = dispatch => ({
  onChangeTopics: (topic, subtopic) => dispatch(changeTopics(topic, subtopic)),
  launchXfinityAssistant: intent => dispatch(launchXfinityAssistant(undefined /* no utterance */, intent)),
});

export const App = connect(mapStateToProps, mapDispatchToProps)(CategoryPage);
